import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["isBottom"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo, forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, border, mq, transition } from '@rexlabs/styling';
import { Breakpoints } from '@rexlabs/breakpoints';
import { Item } from './item';
import { Expander } from './expander';
import { useNavigation } from '../context';
import { WIDTHS } from '../utils/constants';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    position: 'relative',
    width: '100%',
    height: '100%'
  }, transition.styles({
    target: 'navigation.menu',
    property: 'width',
    duration: 'medium',
    easing: 'smooth'
  })), {}, {
    background: function background(_ref) {
      var token = _ref.token;
      return token('navigation.menu.background.color', token('color.container.static.primary.default'));
    }
  }, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      width: function width(_ref2) {
        var token = _ref2.token;
        return token('navigation.mobile.menu.width', WIDTHS.MENU.MOBILE);
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      width: function width(_ref3) {
        var token = _ref3.token;
        return token('navigation.tablet.menu.width', WIDTHS.MENU.TABLET);
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      width: function width(_ref4) {
        var token = _ref4.token;
        return token('navigation.desktop.menu.width', WIDTHS.MENU.DESKTOP);
      }
    }
  }])),
  containerExpanded: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      width: function width(_ref5) {
        var token = _ref5.token;
        return token('navigation.mobile.menu.expanded.width', WIDTHS.EXPANDED_MENU.MOBILE);
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      width: function width(_ref6) {
        var token = _ref6.token;
        return token('navigation.tablet.menu.expanded.width', WIDTHS.EXPANDED_MENU.TABLET);
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      width: function width(_ref7) {
        var token = _ref7.token;
        return token('navigation.desktop.menu.expanded.width', WIDTHS.EXPANDED_MENU.DESKTOP);
      }
    }
  }])),
  items: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto'
  },
  divider: _objectSpread({
    margin: 0,
    opacity: 0.5
  }, border.styles({
    target: 'navigation.menu.divider',
    all: {
      width: 'none'
    },
    top: {
      width: 'thin',
      color: 'container.static.light'
    }
  }))
});
export var Menu = /*#__PURE__*/forwardRef(function Menu(_ref8, ref) {
  var style = _ref8.style,
      className = _ref8.className,
      items = _ref8.items,
      Title = _ref8.Title;
  var s = useStyles(defaultStyles);

  var _useNavigation = useNavigation(),
      activeItem = _useNavigation.activeItem,
      isExpanded = _useNavigation.isExpanded;

  var topItems = useMemo(function () {
    return _filterInstanceProperty(items).call(items, function (_ref9) {
      var isBottom = _ref9.isBottom;
      return !isBottom;
    });
  }, [items]);
  var bottomItems = useMemo(function () {
    return _filterInstanceProperty(items).call(items, function (_ref10) {
      var isBottom = _ref10.isBottom;
      return isBottom;
    });
  }, [items]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, s.with('container', {
    containerExpanded: activeItem || isExpanded
  })({
    style: style,
    className: className
  }), {
    ref: ref,
    flexDirection: "column"
  }), Title && /*#__PURE__*/React.createElement(Title, null), /*#__PURE__*/React.createElement("menu", s('items'), topItems.length > 0 && _mapInstanceProperty(topItems).call(topItems, function (item) {
    return /*#__PURE__*/React.createElement(Item, _extends({
      key: item.id
    }, item));
  }), bottomItems.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", s('divider')), _mapInstanceProperty(bottomItems).call(bottomItems, function (_ref11) {
    var isBottom = _ref11.isBottom,
        item = _objectWithoutProperties(_ref11, _excluded);

    return /*#__PURE__*/React.createElement(Item, _extends({
      key: item.id
    }, item));
  }))), /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      minWidth: 'm'
    }
  }, /*#__PURE__*/React.createElement(Expander, null)));
});